module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }, [_vm._v("1")])]), _c('a', {
    attrs: {
      "id": "ch01"
    }
  }, [_c('p', {
    staticClass: "imagec"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "14",
      "src": "images/line.jpg",
      "width": "100"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "rights"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Lima, Peru")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("El Tocón Sangriento")]), _vm._v("—the Bloody Stump—was a back-alley, low-rent cantina that hadn’t changed in clientele or décor since Mike Brown first set foot in the dump eight years ago. The class of women, however, seemed to have catapulted to new levels.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sun had been down less than an hour when he turned his back to the cracked, smoky mirror, a shot of pisco in one hand, a timeworn jack of hearts in the other. He slid his aviator shades to the top of his head and propped his elbows behind him on the edge of the scarred bar. Then he watched the dance floor with interest as one particular woman, who had caught his eye when he’d walked in two hours ago, moved sensuously to the rhythm of a slow, Spanish guitar.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }, [_vm._v("Absently flipping the playing card back and forth between his fingers, he squinted through the tobacco and marijuana haze at the dark-haired Latina beauty stirring up trouble and testosterone with the seductive ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("sway of her hips. She was way too hot for this dive. And while he didn’t have a clue why she flashed her flirty smile his way, he wasn’t going to question his good luck. Just like he wasn’t questioning the reason he was tying one on like there was no tomorrow.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He tossed back the shot and exchanged it for a full one from the neat row of soldiers lined up on the bar behind him. Screw the fact that he’d been clean and sober for 364 consecutive days . . . a record he never seemed to beat. Today, like every other July 15 since Operation Slam Dunk had gone south, he was getting flat-ass drunk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The end of days. That’s how he thought of the debacle in Afghanistan eight years ago.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sobrietus interruptus. That’s how he thought of his annual commune with alcohol and self-pity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was holding a postmortem. Throwing a pity party. Conducting a wake for the friends who’d lost their lives eight years ago. For the life and career "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("he’d")]), _vm._v(" lost.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hell, call it whatever you wanted—a guilt trip, grief, suppressed rage, self-destruction—he didn’t give a rip. It was happening. The only new wrinkle in his yearly bender was that it was starting to look like he might also get laid.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Talk about poetic justice. He was already fucked up in the head . . . might as well make it a clean sweep.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Eyes on the prize, he slammed back one more shot, pocketed the bullet-ridden playing card, touched the ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("unlit cigarette tucked above his right ear for luck, and pushed off the bar stool. Then he tried like hell not to stagger as he walked unsteadily across the room toward the spicy little enchilada who seemed to only have eyes for him. Big dark eyes. A little sleepy, a little slutty, a "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("lot")]), _vm._v(" interested.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Damn, she was something. Centerfold something. A petite, hot mess of raw sexuality. Long, satiny black hair escaped in sleek, bed-mussed strands from the silver clip she’d used to secure it in a loose knot on top of her head. Elegant neck. Smooth, bare shoulders. A lot of soft, caramel skin. And that red bustier—its B cups not having a lot of luck harnessing a generous pair of Cs—worn with black spandex pants that stopped at her ankles where the straps of her four-inch stilettos took over and played hell with the fit of his pants.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, gorgeous,” he said. Because she was. And because he was too wasted to come up with anything original. He moved in close—crowded the hell out of her personal space—and the way she slid up real close and cuddly told him that she was totally fine with the invasion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Hola")]), _vm._v(".” She smelled sweet and musky and sexually charged as she tipped her head back with a bold, inviting smile and pressed those amazing breasts against his chest. “Nice bling.” A long-nailed fingertip—slick, shiny, red—tapped the diamond stud in his left ear, then lingered at the tip of his lobe.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("“Nice, um”—he let his gaze slide down to that ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("magnificent cleavage before easing back to her face—“smile.”")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She laughed and tilted her head to the side in blatant invitation, giving him an even better view of all that dewy, soft flesh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wanna take this somewhere private?” Might as well cut straight to the chase.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The lady knew what she wanted. “Thought you’d never ask,” she said, her English laced with a sultry, lyrical Spanish accent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her hand was small and hot—like the rest of her—when she took his and led him toward the back door. He followed like a love-struck puppy, mesmerized by the smell of her hair and the sway of her hips and the way her sparkly purse hung from a silver chain looped over her shoulder and rhythmically bumped her gorgeous ass with every step she took.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Outside, the alley was already shadowy and as dark as the desire that ripped recklessly through his groin. Somewhere in the back of his mind, a warning bled through his lust-induced fog, telling him to slow the hell down, reminding him that if he hadn’t been so drunk, he might have asked a few more questions. That maybe, if he added two and two together he might come up with something other than "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("four")]), _vm._v("nicate.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Just because he wanted her to be a working girl didn’t mean she was one. And just because he was drunk didn’t mean he should let his guard down. He started to rethink this entire proposition . . . but then ")]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("she leaned back against the wall, gripped his T-shirt with both hands, and pulled him flush against her.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Good-bye, presence of mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was all hot, wet, open mouth and ripe breasts rubbing up against him, her left leg wedging super sweet between his thighs and moving up and down over his rapidly expanding package as he pressed her against the wall with his body.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He groaned and scrabbled for a hold on his sanity. “Maybe we should get a room, wild thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She laughed, a husky, naughty purr, and bit his lower lip. “That comes later, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("gringo")]), _vm._v(" . . . but "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("you’re")]), _vm._v(" gonna come right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Holy mother.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When she reached into her purse, another spike of alarm jabbed him out of his stupor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Condom.” She flashed that dimpled smile and damn if he didn’t almost weep with gratitude.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What the hell. It was still early, but it was dark. He was gone. And all this lush woman’s heat had him hypnotized by the prospect of her doing him right here, beneath the flashing neon "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("QUILMES")]), _vm._v(" sign.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He skimmed his palms down her sides, pressed the heels of his hands against her superior breasts, then slid them lower again, gripping her hips and rubbing her against his raging erection.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All the while, she had one hand on her purse, while rooting around inside with the other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Damn, sweetheart. If you don’t find that thing soon the party’s gonna be over.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Just then he got wind of a scent . . . and got sober real fast.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He grabbed her wrist, pressed her harder against the wall, and pulled her hand out of her bag. A loop of thin, stiff plastic dangled from her red-tipped nails.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, now.” He glanced at the flex cuffs. “Speaking of bling. I’m all for kinky sex, but there’s no way in hell you’re going to slap that bracelet on me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She wasn’t smiling now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And nice perfume, by the way. Eau du le gun oil?” He felt the outline of a pistol inside that sparkly purse. “Shoulda gone for Shalimar, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("chica . . .")]), _vm._v(" the smell of that stuff makes me stupid.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s not all that makes you stupid,” she muttered and jammed a knee hard into his gonads.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He doubled over with a gasp of pain, helpless to fight her when she yanked his arms behind his back, expertly looped the strip of plastic around both wrists, and jerked it tight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We can do this easy,” she whispered close to his ear, all traces of her Spanish accent gone, as he groaned in agony, “or it can go real hard on you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Well, of course he wasn’t going to go easy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He drove a shoulder toward her midsection. She dodged like a pro and he landed on his face in the alley’s pocked, filthy pavement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the time he felt the prick of the needle in his neck, it was all over but the headache he knew he was going to have when he woke up. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("If")]), _vm._v(" he woke up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Which, unfortunately, he did.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-728235ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 84
// module chunks = 0